import React from "react"
import { Tooltip } from "antd"
import { InboxOutlined } from "@ant-design/icons"
import Strings from "utils/strings"
import { RouteAddress } from "../../types"
import { PICKUP_COLOR, TOOLTIP_COLOR, formatClock } from "./utils"

// Read-only, same idea as DepotMarker — a fixed waypoint, not something the
// user drags. Everything between one PICKUP and the next belongs to it.
const PickupMarker: React.FC<{
	addr: RouteAddress
	left: number
}> = ({ addr, left }) => {
	const tooltipContent = (
		<div style={{ minWidth: 160 }}>
			<div style={{ fontWeight: 600, marginBottom: 4 }}>
				{Strings.routes.bikePickup}
			</div>
			{addr.address && <div style={{ color: "#bfbfbf" }}>{addr.address}</div>}
			<div style={{ marginTop: 4 }}>{formatClock(addr.eta)}</div>
		</div>
	)

	return (
		<Tooltip title={tooltipContent} color={TOOLTIP_COLOR}>
			<div
				style={{
					position: "absolute",
					left: `${left}%`,
					top: "50%",
					transform: "translate(-50%, -50%)",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: 24,
					height: 24,
					background: "#fff",
					border: `2px solid ${PICKUP_COLOR}`,
					borderRadius: 7,
					boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
					// A PICKUP's eta can land on the exact same pixel as its group's
					// first delivery — above a resting pill's zIndex (1) so it never
					// ends up hidden underneath one.
					zIndex: 2,
				}}
			>
				<InboxOutlined style={{ color: PICKUP_COLOR, fontSize: 13 }} />
			</div>
		</Tooltip>
	)
}

export default PickupMarker
